import { ConstantsService } from "@services/constantsService";

export interface IDeviceInfo {
    DeviceId: number;
    IMEI: string;
    SerialNumber: string;
    ICCID: string;
    DeviceTypeId: number;
    DeviceTypeName: string;
    IsAutoDeployment: boolean;
    FirmwareName: string;
    FirstConnected: Date;
    LastConnected: Date;
    FootageStart: Date;
    LastIgnitionChangeTime: Date;
    SDCardLabel: string;
    SDCardModel: string;
    SDCardSerial: string;
    SDCardSizeMB: number;
    SDCardAvailableMB: number;
    InternalMemoryMB: number;
    InternalMemoryAvailableMB: number;
    NetworkOperator: string;
    NetworkAccessPoint: string;
    Lat: number;
    Lon: number;
    Speed: number;
    Heading: number;
    SatCount: number;
    GPSAccuracy: number;
    SupportedChannelCount: number;
    AvailableChannels: string;
    CameraLatestVideos: IS3VideoFile[];
    UpdaterId: number;
    UpdaterVersion: string;
    UpdaterInstallDate: Date;
    TelematicsId: number;
    TelematicsVersion: string;
    TelematicsInstallDate: Date;
    ConfigId: number;
    ConfigName: string;
    ConfigFileInstallDate: Date;
    UpdaterRequestedId: number;
    UpdaterRequestedVersion: string;
    UpdaterRequestedDate: Date;
    UpdaterRequestedStatusId: number;
    UpdaterRequestedStatusName: string;
    UpdaterRequestorUserName: string;
    TelematicsRequestedId: number;
    TelematicsRequestedName: string;
    TelematicsRequestedDate: Date;
    TelematicsRequestedStatusId: number;
    TelematicsRequestedStatusName: string;
    TelematicsRequestorUserName: string;
    ConfigRequestedId: number;
    ConfigRequestedName: string;
    ConfigRequestedDate: Date;
    ConfigRequestedStatusId: number;
    ConfigRequestedStatusName: string;
    ConfigRequestorUserName: string;
    ProdUpdaterId: number;
    ProdUpdaterVersion: string;
    ProdTelematicsId: number;
    ProdTelematicsVersion: string
}

export interface ICameraSimStatus {
    ICCID: string;
    SimPlan: string;
    ReportGroup: number;
    SimRestrictions: string;
    SimState: string;
    LastDataSessionTime: Date;
    IsRegistered: boolean;
    UsageMB: number;

    // ---
    isActive: boolean;
}

export interface IConfigurationUpdateRequest {
    DeviceId: number;
    ConfigFileId: number;
}

export interface IConfigurationFile {
    Archived: boolean;
    ConfigFileId: number;
    ConfigFileUniqueId: string;
    ConfigFileName: string;
    DeviceTypeId: number;
    Url: string;
}


export interface IConfigurationUpdate {
    DeviceId: number;
    IMEI: string;
    DeviceType: string;
    Description: string;
    RequestedDate: Date;
    InstalledDate: Date;
    RequestedUserId: string;
    RequestedUserName: string;
    Status: string;
}

export interface IS3VideoFile {

    FileName: string;
    PresignedUrl: string;

    UploadDate: string;
    ThumbnailUrl: string;
}

export interface ISetAutoUpdateModeRequest {
    DeviceId: number;
    IsAutoDeployment: boolean;
}

export class CameraCommunicationServer {

    apiUrl: string;

    static $inject = ["$http", "$q", "constantsService"];

    constructor(
        private readonly $http: angular.IHttpService,
        private readonly $q: angular.IQService,
        private readonly constantsService: ConstantsService
    ) {
        this.apiUrl = this.constantsService.getApiUrl();
    }

    getDeviceInfo(serial: string): angular.IPromise<IDeviceInfo> {
        if (!serial) {
            console.warn("No serial passed into getDeviceInfo");
            return this.$q.when(null);
        }

        return this.$http({
            url: `/api/communicationServer/device/${serial}/info`,
            method: "GET",
            cache: false
        }).then((response: angular.IHttpPromiseCallbackArg<IDeviceInfo>) => {
            return response.data;
        });
    }

    GetSimStatus(iccid: string): angular.IPromise<ICameraSimStatus> {
        return this.$http({
            url: `/api/communicationServer/sim/${iccid}`,
            method: "GET",
            cache: false
        }).then((response: angular.IHttpPromiseCallbackArg<ICameraSimStatus>) => {
            return response.data;
        });
    }

    getAvailableConfigFiles(deviceTypeId: number, includeArchived: boolean): angular.IPromise<IConfigurationFile[]> {
        return this.$http({
            url: `/api/communicationServer/config/${deviceTypeId}/files`,
            method: "GET",
            params: {
                includeArchived
            },
            cache: false
        }).then((response: angular.IHttpPromiseCallbackArg<IConfigurationFile[]>) => {
            return response.data;
        });
    }

    postConfigUpdate(update: IConfigurationUpdateRequest): angular.IPromise<any> {
        return this.$http({
            url: `/api/communicationServer/config`,
            method: "POST",
            data: update,
            params: { minsToLive: 30 }
        });
    }

    setAutoUpdateMode(request: ISetAutoUpdateModeRequest): angular.IPromise<any> {
        return this.$http({
            url: `/api/communicationServer/autoUpdateMode`,
            method: "POST",
            data: request,
            params: { minsToLive: 30 }
        });
    }

    getConfigurationUpdateHistory(deviceId: number): angular.IPromise<IConfigurationUpdate[]> {
        return this.$http({
            url: `/api/communicationServer/device/${deviceId}/configHistory`,
            method: "GET",
            cache: false
        }).then((response: angular.IHttpPromiseCallbackArg<IConfigurationUpdate[]>) => {
            return response.data;
        });
    }
}
